//region :: Imports ::
import MNSwagClientConfiguration from './NSwagClientConfiguration';

//endregion

/** */
abstract class MNSwagClientBase<TConfig extends MNSwagClientConfiguration> {

    private readonly m_configuration: TConfig;

    /** */
    protected constructor(configuration: TConfig) {
        this.m_configuration = configuration;
    }

    /** */
    protected abstract onGetBaseUrl(baseUrl?: string): string;

    /** */
    protected abstract onTransformOptions(requestOptions: any): Promise<any>;

    /** */
    protected getBaseUrl(baseUrl?: string): string {
        return this.onGetBaseUrl(baseUrl);
    }

    /** */
    protected async transformOptions(requestOptions: any): Promise<any> {

        //
        //  NOTE:
        //  If you change any code here you MUST re-generate the NSwag
        //  output for the changes to take effect
        //

        requestOptions.headers = {
            'M.ApiKey': this.m_configuration.apiKey,
            ...requestOptions.headers
        };

        if(this.m_configuration.requiresAuthentication) {

            const accessToken = await this.m_configuration.accessTokenProvider!.getToken([]);
            requestOptions.headers = {
                ...requestOptions.headers,
                'Authorization': `Bearer ${accessToken}`
            };

        }

        requestOptions = await this.onTransformOptions(requestOptions);

        return requestOptions;

    }

    /** */
    protected get configuration(): TConfig {
        return this.m_configuration;
    }

}

export default MNSwagClientBase;
